import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const serviceNowPickerFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'service-now-picker-form-field-extension',
    params: {
      field: () =>
        import('./service-now-picker').then(m => m.ServiceNowPickerFormField),
    },
  });
